export enum CreditCardProcessingMethods {
    CardConnect = 'CardConnect',
    Stripe = 'Stripe',
    None = 'None',
}
